/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import {getHalfMadeProductList} from "@/api/HalfMadeProduct"

export default {
  addHalfMadeProduct({ commit }, halfMadeProduct) {
    return new Promise((resolve) => {
      commit('ADD_HALF_MADE_PRODUCT', halfMadeProduct)
      resolve()
    })
  },
  fetchDataListItemsHalfMadeProduct({ commit },payload) {
    return new Promise((resolve, reject) => {
      getHalfMadeProductList(payload)
      .then((response) => {
        if(response.status === 200){
        commit('SET_HALF_MADE_PRODUCT', response.data);
        resolve(response);
        }else{
          reject(new Error("Listeleme İşlemi Başarısız ! " + response.status));
        }
      })
      .catch(() => {
        reject(new Error("Sunucu Bağlantısı Başarısız !"));
      })
    })
  },
  updateHalfMadeProduct({ commit }, halfMadeProduct) {
    return new Promise((resolve) => {
      commit('UPDATE_HALF_MADE_PRODUCT', halfMadeProduct)
      resolve()
    })
  },
  removeHalfMadeProduct({ commit }, halfMadeProductId) {
    return new Promise((resolve) => {
      commit('REMOVE_HALF_MADE_PRODUCT', halfMadeProductId)
          resolve();
    })
  },
};